import { render, staticRenderFns } from "./AcceptParticipantInvitation.vue?vue&type=template&id=7ddaa1db"
import script from "./AcceptParticipantInvitation.vue?vue&type=script&lang=ts"
export * from "./AcceptParticipantInvitation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports